import permissions from '../permissions'

const COOKIES_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.COOKIES.MANAGE,
  },
]

export default COOKIES_LIST
